


import { Routes, RouterModule } from '@angular/router';
import { LogDataComponent } from './logdata.component';

const routes: Routes = [
    {
        path: '',
        component: LogDataComponent
    },
];

export const LogDataRoutes = RouterModule.forChild(routes);
